module.exports = __webpack_public_path__ + "images/2cc0a8142c9e6cade5279c58587e21e0.png";